import { CheckCircle2 } from "lucide-react";
import { BrandHeader } from "@/pages/PayOrder";

export default function PurchaseSuccess() {
  const err = new URLSearchParams(window.location.search).get("status") === "error";
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <BrandHeader />
      <main className="mx-auto max-w-xl px-4 py-16 text-center" data-testid="purchase-success-page">
        {err ? (
          <>
            <h1 className="font-display text-3xl text-[#0B192C]">Hubo un problema con tu pago</h1>
            <p className="mt-3 text-slate-600">No se completó el cargo. Puedes volver a abrir tu link de pago o contactar a tu asesor.</p>
            <p className="mt-2 text-slate-500 text-sm">There was a problem with your payment. Please reopen your payment link or contact your advisor.</p>
          </>
        ) : (
          <>
            <CheckCircle2 className="mx-auto h-16 w-16 text-emerald-500" />
            <h1 className="mt-4 font-display text-3xl sm:text-4xl text-[#0B192C]">¡Gracias! Tu pago fue recibido</h1>
            <p className="mt-3 text-slate-600">En unos minutos recibirás tu correo de confirmación con los detalles de tu reservación.</p>
            <p className="mt-6 text-slate-500 text-sm">Thank you! Your payment was received. You will get a confirmation email shortly.</p>
            <p className="mt-10 font-display italic text-lg text-[#0B192C]">Your next legendary journey starts here!</p>
          </>
        )}
      </main>
    </div>
  );
}
